import { render, staticRenderFns } from "./AdminSpecialistBookingsArchive.vue?vue&type=template&id=6e8f1a0c"
import script from "./AdminSpecialistBookingsArchive.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistBookingsArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports